import { EFeedMode, EFeedSort } from '~/features-shared/content/stores/contents'

import { useLocalStorageManager } from '~/features-generic/config-manager/utils/local-storage-manager'

/**
 * Last conversation feed mode state (large, compact or timeline)
 * Saved in LocalStorage
 */
export const useConversationFeedMode = createGlobalState(
  () => useLocalStorageManager<EFeedMode>('feed_mode-conversation', EFeedMode.Timeline),
)

/**
 * Last conversation feed sort state (creation or update)
 * Saved in LocalStorage
 */
export const useConversationFeedSort = createGlobalState(
  () => useLocalStorageManager<EFeedSort>('feed_sort-conversation', EFeedSort.Creation),
)

/**
 * URI of the last visited conversation - or "".
 * Saved in LocalStorage
 */
export const useLastVisitedConversation = createGlobalState(
  () => useLocalStorageManager<string>('last_visited_conversation', ''),
)
